import Stack from '@mui/material/Stack';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import Radio from 'components/form/Radio';
import React, { useState, useMemo } from 'react';
import {
  deleteCategoryItem,
  saveCategoryItem,
} from 'services/categories.service';
import toast from 'utils/toast';

const MoveToFolderDialog = ({
  onClose,
  folders,
  itemId,
  existingCategoryItemHash,
  existingCategoryId,
  getCategories,
}) => {
  const [selectedFolder, setSelectedFolder] = useState();
  const onSave = async () => {
    try {
      if (selectedFolder === '0') {
        await deleteCategoryItem(existingCategoryItemHash);
        await getCategories();
        onClose();
        return;
      }
      await saveCategoryItem({
        hash: existingCategoryItemHash,
        category_id: selectedFolder,
        object_id: itemId,
      });
      await getCategories();
      onClose();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const filteredFolders = useMemo(() => {
    return folders.filter((i) => i.category_id !== existingCategoryId);
  }, [folders]);

  return (
    <Modal
      title="Move To Folder"
      actions={[
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>,
        <Button disabled={!selectedFolder} onClick={onSave}>
          Save
        </Button>,
      ]}
    >
      <Stack>
        {existingCategoryItemHash && (
          <Radio
            color="error"
            name="folder"
            value={0}
            label="Remove from folder"
            checked={selectedFolder === '0'}
            onChange={(e) => setSelectedFolder(e.target.value)}
          />
        )}
        {filteredFolders.map((i) => (
          <Radio
            key={i.hash}
            label={i.category_name}
            name="folder"
            value={i.category_id}
            checked={selectedFolder === i.category_id}
            onChange={(e) => setSelectedFolder(e.target.value)}
            id={i.hash}
          />
        ))}
      </Stack>
    </Modal>
  );
};

export default MoveToFolderDialog;
